"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get EmployeeCustomFieldUpdates () {
        return EmployeeCustomFieldUpdates;
    },
    get GetEmployeeDetailsByFieldParams () {
        return GetEmployeeDetailsByFieldParams;
    },
    get GetEmployeeDetailsParams () {
        return GetEmployeeDetailsParams;
    },
    get GetEmployeeHistoryByIdParams () {
        return GetEmployeeHistoryByIdParams;
    },
    get PatchEmployeeActivationRequest () {
        return PatchEmployeeActivationRequest;
    },
    get PatchEmployeeBulkDetailsRequest () {
        return PatchEmployeeBulkDetailsRequest;
    },
    get PatchEmployeeDetailsRequest () {
        return PatchEmployeeDetailsRequest;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const EmployeeCustomFieldUpdates = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    value: _models.FieldValueModel,
    comment: _zod.z.string().optional()
});
const PatchEmployeeDetailsRequest = _zod.z.object({
    updates: _zod.z.array(EmployeeCustomFieldUpdates),
    asOf: _utilsisomorphic.transformDate
});
const PatchEmployeeBulkDetailsRequest = _zod.z.array(_zod.z.object({
    employeeId: _utilsisomorphic.transformObjectId,
    updates: _zod.z.array(EmployeeCustomFieldUpdates),
    asOf: _utilsisomorphic.transformDate
}));
const PatchEmployeeActivationRequest = _zod.z.object({
    activation: _zod.z.boolean(),
    terminationDate: _utilsisomorphic.transformDate.optional(),
    managerReassignmentId: _utilsisomorphic.transformObjectId.optional()
});
const GetEmployeeDetailsParams = _zod.z.object({
    id: _utilsisomorphic.transformObjectId.optional()
});
const GetEmployeeDetailsByFieldParams = _zod.z.object({
    id: _utilsisomorphic.transformObjectId,
    fieldId: _utilsisomorphic.transformObjectId
});
const GetEmployeeHistoryByIdParams = _zod.z.object({
    id: _utilsisomorphic.transformObjectId,
    historyId: _utilsisomorphic.transformObjectId
});
